import { usePostApi, type WriteApiOptions } from "@shared/api/hooks";
import { AUTH_REQUEST_RESET_PASSWORD_SERVICE_NAME } from "../constants";
import type { ForgotPassword } from "../types";

export type UseForgotPasswordApiOptions = Omit<
  WriteApiOptions<null, ForgotPassword>,
  "serviceName" | "idRequired"
>;

/**
 * Step 1 of the reset flow — `POST /v1/{actor}/request-reset-password`.
 *
 * Mails a 6-digit code and resolves no payload; the envelope's localized
 * message is the user feedback (`showSuccessToast: true`, or read it in
 * `onSuccess`).
 *
 * Note an unknown address comes back as a 404 ("Wrong email") rather than a
 * uniform success, so the UI should avoid echoing that distinction back.
 */
export function useForgotPasswordApi(options?: UseForgotPasswordApiOptions) {
  return usePostApi<null, ForgotPassword>({
    serviceName: AUTH_REQUEST_RESET_PASSWORD_SERVICE_NAME,
    invalidateKeys: false,
    ...options,
  });
}
